const fontSizesNumbers = [
  18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 96,
  120, 150, 200, 300
]

export { fontSizesNumbers }
